
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 341.59 203.057","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.063 0h341.47v202.17H.063z","fill":"#fff"}}),_c('path',{attrs:{"d":"M.063 20v56.5h96z","fill":"#13135f"}}),_c('path',{attrs:{"d":"M109.91 76.5h19.652L.062 0v12z","fill":"red"}}),_c('path',{attrs:{"d":"M37.916 0l109.65 67.486V0z","fill":"#12145b"}}),_c('path',{attrs:{"d":"M341.56 182v-56h-95z","fill":"#13135f"}}),_c('path',{attrs:{"d":"M232.72 126h-19.652l128.5 76.125V190z","fill":"red"}}),_c('path',{attrs:{"d":"M304.68 203l-109.65-67.486V203z","fill":"#12145b"}}),_c('path',{attrs:{"d":"M341.56 20.513V76.5l-95-.068z","fill":"#13135f"}}),_c('path',{attrs:{"d":"M195.06 76.5h22.298L341.558 0h-22.554z","fill":"red"}}),_c('path',{attrs:{"d":"M303.75 0L195.06 66.986V0z","fill":"#12145b"}}),_c('path',{attrs:{"d":"M.071 182.48v-56.5h96z","fill":"#13135f"}}),_c('path',{attrs:{"d":"M147.52 125.97h-22.299L.001 203.058h22.572z","fill":"red"}}),_c('path',{attrs:{"d":"M37.87 202.97l109.65-67.486v67.486z","fill":"#12145b"}}),_c('path',{attrs:{"d":"M156.72 0h28.874v203H156.72z","fill":"red"}}),_c('path',{attrs:{"d":"M.063 85.252h341.53v32.672H.063z","fill":"red"}})])
          )
        }
      }
    